import { F } from './fancybox-BA187ItQ.js';

/**
 * CartMediaGallery Web Component
 *
 * Wraps the cart line items and opens a Fancybox gallery with just the photos of
 * the clicked product (never the product page).
 *
 * Each line item renders:
 *   <a data-fancybox-cart data-fancybox="cart-media-{key}" data-src="…">…</a>
 * plus one hidden <a> per remaining product photo, sharing the same
 * data-fancybox group so only that product's images show up in the lightbox.
 *
 * Fancybox binds via event delegation on <body>, so it keeps working after the
 * cart re-renders its line items.
 */
class CartMediaGallery extends HTMLElement {
  #fancyboxInstance;

  connectedCallback() {
    this.#fancyboxInstance = F.bind('[data-fancybox-cart]', {
      groupAll: false,
      Carousel: {
        Thumbs: {
          type: 'classic',
        },
        Toolbar: {
          display: {
            left: [],
            middle: [],
            right: ['close'],
          },
        },
      },
    });
  }

  disconnectedCallback() {
    this.#fancyboxInstance?.();
  }
}

if (!customElements.get('cart-media-gallery')) {
  customElements.define('cart-media-gallery', CartMediaGallery);
}
